import React, {Component} from 'react';
import {Grid,Cell} from 'react-mdl';
import Education from './education';
import Skills from './progress'
import { inherits } from 'util';

class Resume extends Component{
    render(){
        return(
        <div>
          <Grid>
            <Cell col={4}>
              <div style={{textAlign:"center"}}>
                <img
                src="https://cdn2.iconfinder.com/data/icons/male-users-2/512/1-512.png"
                alt = "avatar"
                style={{height:"300px"}}
                />
                <h2 style={{paddingTop:"1em",fontFamily:"Anton"}}>Mrityunjoy Nath</h2>
                <h4 style={{color:"grey"}}>Software Developer</h4>
                <hr style={{borderTop:"3px solid darkGrey" ,paddingLeft:"8em",paddingRight:"8em", width:"50%"}}/>
                </div>
                <p>
                Having no limit is my goal. Connecting with everyone to know every detail and use most advanced mechinery.
                </p>
                <hr style={{borderTop:"3px solid darkGrey", width:"50%"}}/>
                <h5> Address</h5>
                <p>
                  3314 H3 NIT Silchar Campus
                </p>
                <h5> Mobile </h5>
                <p>
                  9678452532
                </p>
                <h5> E-Mail </h5>
                <p>
                  <a href ="mailto:mrityunjoynath10@gmail.com" rel="noopener noreferrer" style={{textDecoration:"none",color:"inherit"}}>mrityunjoynath10@gmail.com</a>
                </p>
                <hr style={{borderTop:"3px solid darkGrey" , width:"50%"}}/>
            </Cell>
            <Cell col={8} className="resume-right">
              <h2>Education</h2>
              <Education
              startYear={2016}
              endYear={2020}
              descrip="B.Tech in Computer Science and Engineering"
              Name="NIT Silchar"
              />
              <Education
              startYear={2014}
              endYear={2016}
              descrip="Higher Secondary"
              Name="JNV Bongaigaon"
              />
              <hr style={{fontColor:"darkGrey"}}/>
              <h2 style={{paddingTop:"1em"}}>Skills</h2>
              <Skills
                skill1="C" skill2="C++" skill3="Python"
                progress={60}
              />
              
              <Skills
                skill1="JAVA" skill2="HTML" skill3="CSS"
                progress={50}
              />

              <Skills
                skill1="Javascript" skill2="SQL" skill3="mySQL"
                progress={50}
              />

              <Skills
                skill1="React.js" skill2="Node.js" skill3="React-Native"
                progress={50}
              />

              <Skills
                skill1="Android" skill2="{ML}" skill3="D3.js"
                progress={50}
              />

            </Cell>
          </Grid>
        </div>
        );
    }
}

export default Resume;



// WEBPACK FOOTER //
// ./src/Components/resume.js